export enum NotificationTypeEnum {
  Dashboard_Updated = 1,
  Appointment_Created,
  Appointment_Updated,
  Upcoming_Appointment,
  Appointment_Completed,
  Appointment_Cancelled,
  Treatment_Created,
  Treatment_Updated,
  Treatment_Completed,
  Treatment_Cancelled,
  New_Work_Order,
  Work_Order_Created,
  Work_Order_Updated,
  Work_Order_Approved,
  Work_Order_In_Design,
  Work_Order_In_Production,
  Work_Order_Shipped,
  Work_Order_Completed,
  Work_Order_Due_Date_Approaching,
  Work_Order_Due_Date_Delayed,
  Payment_Created,
  Payment_Updated,
  Payment_Received,
  Payment_Completed,
  Payment_Cancelled,
  Payment_Refunded,
  Payment_Due_Soon,
  Payment_Delayed,
  System_Updated,
  Maintenance_Scheduled,
  Subscription_Started,
  Subscription_Cancelled,
  Subscription_Renewing_Soon,
  Trial_Period_Ending_Soon,
  Trial_Period_Ended,
  Organization_Updated,
  Branch_Added,
  Branch_Updated,
  Branch_Removed,
  User_Invited,
  User_Invitation_Accepted,
  User_Removed,
  User_Information_Updated,
  Service_Added,
  Service_Updated,
  Service_Removed,
  Service_Activated,
  Service_Deactivated,
  Service_Group_Added,
  Service_Group_Updated,
  Service_Group_Removed,
  Doctor_Assigned,
  Doctor_Assignment_Removed,
  Price_List_Created,
  Price_List_Updated,
  Price_List_Removed,
  Price_List_Activated,
  Price_List_Deactivated,
  Partner_Added,
  Partner_Removed,
  Partner_Invitation_Accepted,
  Partner_Invitation_Rejected,
  Design_Project_Created,
  Design_Project_Removed,
}

export enum NotificationSubTypeEnum {
  Panel = 1,
  Appointment,
  Treatment,
  Work_Order,
  Payment,
  System,
  DesignProject,
  Subscription,
  Organization,
  Users,
  ServiceList,
  PriceLists,
  Partners,
}

export interface NotificationDto {
  id: string;
  sharingUserId: string;
  sharedUserId: string;
  isAdmin: boolean;
  isSystem: boolean;
  isAllUser: boolean;
  isRead: boolean;
  entityId: string;
  entity2Id: string | null;
  type: NotificationTypeEnum | number;
  subType?: NotificationSubTypeEnum | number;
  title: string;
  description: string;
  parameters: unknown;
  date: string;
  modifiedBy: number;
}

export interface NotificationItem {
  id: string;
  sharingUserId: string;
  sharedUserId: string;
  isAdmin: boolean;
  isSystem: boolean;
  isAllUser: boolean;
  entityId: string;
  entity2Id: string | null;
  title: string;
  description: string;
  parameters: unknown;
  date: string;
  time: string;
  type: NotificationTypeEnum | number;
  subType?: NotificationSubTypeEnum | number;
  icon: string;
  unread: boolean;
  modifiedBy: number;
}
